var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', [_vm._v("보유 포인트 조회")]), _c('section', {
    staticClass: "mt-4"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _c('example-layout', {
    staticClass: "overflow-auto mt-8",
    scopedSlots: _vm._u([{
      key: "render",
      fn: function fn() {
        return [_c('example-my-point')];
      },
      proxy: true
    }, {
      key: "editor",
      fn: function fn() {
        return [_c('prism-editor', {
          staticClass: "rounded",
          attrs: {
            "line-numbers": ""
          },
          model: {
            value: _vm.section1.exampleCode,
            callback: function callback($$v) {
              _vm.$set(_vm.section1, "exampleCode", $$v);
            },
            expression: "section1.exampleCode"
          }
        })];
      },
      proxy: true
    }])
  })], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b', [_vm._v("1. this.$store.dispatch(\"getUser\")")]), _c('p', [_vm._v("회원정보를 로드/리로드합니다. 회원정보 안에 포인트정보(point)가 포함되어 있습니다.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b', [_vm._v("2. this.$store.state.user")]), _c('p', [_vm._v("1에서 로드한 회원정보에 접근하는 방법입니다. "), _c('br'), _vm._v("computed 안에 리네임 형태로 사용하는 편이 작업시간을 절약 할 수 있습니다. "), _c('br'), _vm._v("아래 예제에서는 me로 단축해서 사용합니다.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b', [_vm._v("* 기타")]), _c('p', [_vm._v("예제에서는 비회원이거나 회원정보가 로드되지 않아 정보가 없을때 에러방지를 위해,"), _c('br'), _vm._v(" ?(Optional Chaining) 접근 방법으로 포인트를 표시하고 있습니다."), _c('br'), _vm._v(" format 함수를 제거하면 금액 쉼표 없이 숫자만 표시 할 수 있습니다.")])]);
}]

export { render, staticRenderFns }